<template>
  <WsDialog
    ref="WsDialog"
    :title="_title"
    v-model="dialog"
  >
    <template v-slot:content>
      <slot
        v-if="$_checkSlotHasContent('content')"
        name="content"
        :item="item"
      ></slot>
      <WsEasyTable
        v-else
        :fields="fields"
        :modelData="item"
      />
    </template>
    <template v-slot:leftActions>
      <slot
        name="leftActions"
        :item="item"
      ></slot>
      <WsBtn
        v-if="deletable"
        @click="$_onDelete()"
        alert
      >刪除</WsBtn>
    </template>
    <template v-slot:rightActions>
      <slot
        name="rightActions"
        :item="item"
      ></slot>
      <template v-if="copyable">
        <WsBtn
          v-if="pageMode"
          :to="_copyUrl"
        >複製</WsBtn>
        <WsBtn
          v-if="!pageMode"
          @click="$_onCopy()"
        >複製</WsBtn>
      </template>
      <template v-if="updatable">
        <WsBtn
          v-if="pageMode&&!dialogUpdate"
          :to="$_getUpdateUrl(item)"
          @click="$_onUpdate()"
          outlined
        >編輯</WsBtn>
        <WsBtn
          v-else
          @click="$_onUpdate()"
          outlined
        >編輯</WsBtn>
      </template>
    </template>
  </WsDialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    item: null,
    itemIndex: null,
    // tableItem: null,
  }),
  methods: {
    $_checkSlotHasContent(slotName) {
      if (this.$slots[slotName] || this.$scopedSlots[slotName]) {
        return true;
      } else {
        return false;
      }
    },
    $_onCopy() {
      this.$emit("copy", {
        item: this.item,
        itemIndex: this.itemIndex,
      });
    },
    $_onUpdate() {
      this.$emit("update", {
        item: this.item,
        itemIndex: this.itemIndex,
      });
    },
    $_onDelete() {
      this.$emit("delete", {
        item: this.item,
        itemIndex: this.itemIndex,
      });
    },
    open(item, itemIndex) {
      this.item = item;
      this.itemIndex = itemIndex;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    $_getUpdateUrl(item) {
      if (this.getUpdateUrl) {
        return this.getUpdateUrl(item);
      } else {
        return `/${this.modelName}/${item.id}/update`;
      }
    },
  },
  computed: {
    _copyUrl() {
      return `/${this.modelName}/create?copyfrom=${this.item.id}`;
    },
    _title() {
      if (!this.item) {
        return null;
      } else {
        return this.item[this.titleKey];
      }
    },
  },
  props: {
    getUpdateUrl: {
      type: Function,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    dialogUpdate: {
      type: Boolean,
      default: false,
    },
    pageMode: {
      type: Boolean,
      default: false,
    },
    deletable: {
      type: Boolean,
      default: true,
    },
    updatable: {
      type: Boolean,
      default: true,
    },
    copyable: {
      type: Boolean,
      default: false,
    },
    titleKey: {
      type: String,
      default: "name",
    },
    fields: Object,
  },
};
</script>

<style>
</style>